module.exports = "/fonts/ebilling-logotype-d-815f19907948a229068a76d5860d3685.svg";